// extracted by mini-css-extract-plugin
export default {"descriptionField":"form_descriptionField__iADUE","descriptionLabel":"form_descriptionLabel__-pH+E","error":"form_error__cXTGy"};